import { t } from 'i18next';
import { useState } from 'react';
import { SubTabs } from '../SubTabs';
import { TableUnits } from '../Tables/TableUnits';
import { TableClasses } from '../Tables/TableClasses';
import { Profile } from '~/helpers/userProfile';
import { SimpleButton } from '../styles';
import { ApiResps } from '~/providers';
import { UnitsDisponibility } from '../ClientPanel';
import { Link } from 'react-router-dom';

export type UnitPanelProps = {
  state: {
    deleteUnitsOpen: boolean;
    unitsDispLoading: boolean;
    waterList: ApiResps['/get-integrations-list/water']['list'];
    unitsDisp: UnitsDisponibility;
    units: ApiResps['/clients/get-units-list'] & ({
      groups?: {}[]
      duts?: {}[]
      DACS_COUNT?: number
      DUTS_COUNT?: number
      DAMS_COUNT?: number
      DRIS_COUNT?: number
      disp?: number
    })[];
    energyMetersList: ApiResps['/energy/get-energy-list']['list'];
    classesList: { CLASS_ID: number, CLASS_TYPE: string, CLASS_NAME: string }[];
  };
  setState: (newState: { openModal?: string, deleteUnitsOpen?: boolean }) => void;
  openCreateEditUnit: () => void;
  toggleUnitReport: (id: string) => void;
  getDuts: () => void;
  deleteUnits: (units: { UNIT_ID: number; checked: boolean }[]) => Promise<void>
  deleteClass: (item) => void;
  profile: Profile;
  clientId: number;
  calculateClientUnitsDisp: (clientId: number) => void;
  openCreateEditClass: (itemToEdit?: { CLASS_ID: number, CLASS_TYPE: string, CLASS_NAME: string }) => void
}
export const UnitPanel = ({
  state,
  setState,
  openCreateEditUnit,
  toggleUnitReport,
  getDuts,
  deleteUnits,
  clientId,
  deleteClass,
  openCreateEditClass,
  profile,
  calculateClientUnitsDisp,
}: UnitPanelProps): JSX.Element => {
  const [activeTab, setActiveTab] = useState(t('unidades'));

  return (
    <>
      <SubTabs
        tabs={[t('unidades'), t('classeDeUnidades')]}
        activeTab={activeTab}
        onChange={setActiveTab}
      />
      {activeTab === t('unidades') && (
        state.units.length === 0 ? (
          <div>{`(${t('nenhuma')})`}</div>
        ) : (
          <>
            {(profile.manageAllClients)
                && (
                  <div>
                    <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={() => openCreateEditUnit()}>{t('adicionarUnidade')}</SimpleButton>
                    {state.units.length !== 0
                      && (
                      <>
                        {(profile.permissions.isSuperAdmin) && (
                          <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={() => setState({ deleteUnitsOpen: true })}>{t('excluirUnidades')}</SimpleButton>
                        )}
                        <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={() => setState({ openModal: 'disponibility-export' })}>{t('exportarDisponibilidade')}</SimpleButton>
                        <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={() => calculateClientUnitsDisp(clientId)}>{t('calcularDisponibilidadeUltimos7Dias')}</SimpleButton>
                        <Link to={`/painel/adicionar-lote/responsaveis?idcliente=${clientId}`}>
                          <SimpleButton style={{ fontSize: '80%' }} variant="primary">{t('atribuicaoAutomaticaResponsaveis')}</SimpleButton>
                        </Link>
                      </>
                      )}
                  </div>
                )}
            <TableUnits
              list={state.units}
              energyMeters={state.energyMetersList}
              waterList={state.waterList}
              unitsDisp={state.unitsDisp}
              unitsDispLoading={state.unitsDispLoading}
              onEditClick={openCreateEditUnit}
              onToggleReportClick={toggleUnitReport}
              renderUnits={() => getDuts()}
              deleteUnitsOpen={state.deleteUnitsOpen}
              onDeleteUnits={deleteUnits}
              onCloseDeleteUnits={() => setState({ deleteUnitsOpen: false })}
            />

          </>
        )
      )}
      {activeTab === t('classeDeUnidades') && (
        (state.classesList.length === 0) ? (
          <div>{`(${t('nenhuma')})`}</div>
        ) : (
          <>
            {profile.manageAllClients && (
              <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={() => openCreateEditClass()}>{t('adicionarClasseDeUnidades')}</SimpleButton>
            )}
            <TableClasses
              list={state.classesList}
              clientId={clientId}
              onDeleteClick={deleteClass}
              onEditClick={openCreateEditClass}
            />
          </>

        )
      )}
    </>
  );
};
